import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface RecognitionTop5Unit {
  rank: number;
  unitName: string;
  country: string;
  flag: string;
  isCurrent?: boolean;
}


@Component({
  selector: 'app-recognition-top5-modal',
  standalone: true,
  imports: [
    TranslateModule,CommonModule],
  templateUrl: './recognition-top5-modal.component.html',
  styleUrls: ['./recognition-top5-modal.component.scss'],
})
export class RecognitionTop5ModalComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() headerIcon = 'assets/performance/award.svg';
  @Input() units: RecognitionTop5Unit[] = [];
  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }
}
